import { createSlice } from "@reduxjs/toolkit";

import { APIErrorResponseSchema, V2ErrorResponseSchema } from "../../actions";
import { createGenericReducers, errorSideEffects, RTKSideEffectSchema, successSideEffects, updatingSideEffects } from "..";
import { Toastify } from "../../../components/Toaster";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../services/analytics/tracking";
// Removed unused import

export interface NewPasskeyAuthenticationSchema extends RTKSideEffectSchema, APIErrorResponseSchema, MutationTrackingState {
  Data?: PasskeyPayloadSchema;
}
export interface PasskeyPayloadSchema extends V2ErrorResponseSchema {
  IsEnabled: boolean;
  LocalEnrollment?: boolean;
  PasskeySelection?: string;
  Attestation?: string;
  ProgressiveEnrollment?: boolean;
  ProgressiveEnrollmentDelay?: number;
  RPDisplayName?: string;
  RPID?: string;
  RPOrigins?: string[];
}

const initialState: NewPasskeyAuthenticationSchema = {
  Data: { IsEnabled: false },
  isLoading: false,
  isDeleting: false,
  isUpdating: false,
  isSuccess: false,
  isError: false
};

const passkeySlice = createSlice({
  name: "passkey",
  initialState,
  reducers: {
    getPasskeyRequest: createGenericReducers<NewPasskeyAuthenticationSchema, PasskeyPayloadSchema>({}).request,
    getPasskeySuccess: createGenericReducers<NewPasskeyAuthenticationSchema, PasskeyPayloadSchema>({}).success,
    getPasskeyError: createGenericReducers<NewPasskeyAuthenticationSchema, string>({}).failure,
    updatePasskeyRequest(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updatePasskeySuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state, "success"));
      state.Data = action.payload;
      Toastify("success", "Passkeys Updated successfully");
    },
    updatePasskeyError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state, "error"));
      state.error = action.payload;
    }
  }
});

export const { getPasskeyRequest, getPasskeySuccess, getPasskeyError, updatePasskeyRequest, updatePasskeySuccess, updatePasskeyError } = passkeySlice.actions;

export default passkeySlice.reducer;
